import { UseFormReturn, useWatch } from 'react-hook-form';
import { ServiceRotationFormType } from './types';
import { useEffect, useState } from 'react';
import { ServiceRotationOption, ServiceRotationTypeCapabilityOption } from '@mark43/cad-api';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';

export function useRecommendedServiceProvider(form: UseFormReturn<ServiceRotationFormType>) {
    const { enhancedServiceRotation: isEnhancedServiceRotationEnabled } = useEnabledFeatures();
    const [recommendation, setRecommendation] = useState<ServiceRotationOption | undefined>(
        undefined
    );
    const rotationArea = useWatch({
        control: form.control,
        name: isEnhancedServiceRotationEnabled ? 'serviceRotationArea' : 'serviceRotationList',
    });
    const capability = useWatch({
        control: form.control,
        name: 'serviceRotationTypeCapability',
    });

    useEffect(
        function updateRecommendation() {
            const recommendationFromRotationArea = rotationArea?.recommendation;

            if (capability) {
                const recommendationHasMatchingCapability = recommendationFromRotationArea?.serviceRotationTypeCapabilityIds?.includes(
                    capability.value
                );
                if (recommendationHasMatchingCapability) {
                    setRecommendation(recommendationFromRotationArea);
                } else {
                    setRecommendation(
                        getRecommendation(rotationArea?.serviceRotationOptions ?? [], capability)
                    );
                }
            } else {
                setRecommendation(recommendationFromRotationArea);
            }
        },
        [rotationArea, capability]
    );

    return recommendation;
}

function getRecommendation(
    serviceProviders: ServiceRotationOption[],
    capability: ServiceRotationTypeCapabilityOption | null
): ServiceRotationOption | undefined {
    if (capability === null) {
        return undefined;
    }

    return serviceProviders.find((option) =>
        option.serviceRotationTypeCapabilityIds.includes(capability.value)
    );
}
